import React, { useMemo } from "react";
import { Bar, ComposedChart, XAxis, ResponsiveContainer } from "recharts";
import GraphLoader from "../../components/GraphLoader";

const PvsystActualGHIContainer = ({
  GHIGTI,
  loading,
  progressValueAnimate,
  setProgressValueAnimate,
}) => {
  const filteredData = useMemo(() => {
    if (GHIGTI?.length > 0) {
      return {
        pvsystGHISum: Number(
          Number(
            GHIGTI?.reduce((acc, curr) => acc + (curr?.["PVsyst GHI"] || 0), 0)
          ).toFixed(2)
        ),
        actualGHISum: Number(
          Number(
            GHIGTI?.reduce((acc, curr) => acc + (curr?.["Actual GHI"] || 0), 0)
          ).toFixed(2)
        ),
        pvsystGHILen: GHIGTI?.reduce(
          (acc, curr) => acc + (curr?.["PVsyst GHI"] ? 1 : 0),
          0
        ),
        actualGHILen: GHIGTI?.reduce(
          (acc, curr) => acc + (curr?.["Actual GHI"] ? 1 : 0),
          0
        ),
      };
    }
    return {
      pvsystGHISum: null,
      actualGHISum: null,
      pvsystGHILen: 0,
      actualGHILen: 0,
    };
  }, [GHIGTI]);
  return (
    <div className="detail_overview_1">
      {loading ? (
        <div style={{ height: "100%", width: "100%" }}>
          <GraphLoader />
        </div>
      ) : !GHIGTI || GHIGTI?.length == 0 ? (
        <div style={{ height: "100%", width: "100%", fontSize: "2vmin" }}>
          <p>PVsyst GHI (kWh/m^2) and Actual GHI</p>
          <p>Data Not Available</p>
        </div>
      ) : (
        <>
          <div>
            <span style={{position:"absolute",fontSize:"0.8rem", top: 0, left: 0,right:0 }}>{GHIGTI?.[0]?.Date} to {GHIGTI?.[GHIGTI?.length-1]?.Date}</span>

            <div>
              <div>
                <progress
                  className="progress_4"
                  style={{
                    accentColor: "green",
                    borderRadius: "14px",
                    border: progressValueAnimate.progress4
                      ? "3px solid red"
                      : "none",
                  }}
                  value={filteredData.pvsystGHISum}
                  max={Math.ceil(filteredData.pvsystGHISum) + 100 || 0}
                />
              </div>
              <div>
                <span>PVsyst GHI (kWh/m^2)</span>
                <span
                  style={{
                    position: "absolute",
                    left: `${
                      (filteredData.pvsystGHISum * 100) /
                        Math.ceil(filteredData.pvsystGHISum + 100) -
                      3
                    }%`,
                    bottom: "60%",
                  }}
                >
                  <i class="fa-solid fa-caret-up"></i>
                </span>
                <span>{filteredData.pvsystGHISum || "N/A"}</span>
              </div>
            </div>
            <div>
              <div>
                <progress
                  className="progress_5"
                  style={{
                    accentColor: "green",
                    borderRadius: "14px",
                    border: progressValueAnimate.progress5
                      ? "3px solid black"
                      : "none",
                  }}
                  value={filteredData.actualGHISum}
                  max={filteredData.actualGHISum + 100}
                />
              </div>
              <div>
                <span>Actual GHI (kWh/m^2)</span>
                {/* <span style={{fontSize:"1.2rem"}}><ArrowDropUpIcon  /></span> */}
                <span
                  style={{
                    position: "absolute",
                    left: `${
                      (filteredData.actualGHISum * 100) /
                        (Math.ceil(filteredData.actualGHISum) + 100) -
                      3
                    }%`,
                    bottom: "60%",
                  }}
                >
                  <i class="fa-solid fa-caret-up"></i>
                </span>
                <span>{filteredData.actualGHISum || "N/A"}</span>
              </div>
            </div>
            <div>
              <div>
                <progress
                  className="progress_3"
                  style={{ accentColor: "blue" }}
                  value={
                    filteredData.pvsystGHISum && filteredData.actualGHISum
                      ? ((filteredData.pvsystGHISum -
                          filteredData.actualGHISum) *
                          100) /
                        filteredData.pvsystGHISum
                      : 0
                  }
                  max="100"
                />
              </div>
              <div>
                <span>Excess(+)/ShortFall(-) (%)</span>
                {/* <span style={{fontSize:"1.2rem"}}><ArrowDropUpIcon  /></span> */}
                <span
                  style={{
                    position: "absolute",
                    left: `${
                      Math.abs(
                        filteredData.pvsystGHISum && filteredData.actualGHISum
                          ? ((filteredData.actualGHISum -
                              filteredData.pvsystGHISum) *
                              100) /
                              filteredData.pvsystGHISum
                          : 0
                      ) - 3
                    }%`,
                    bottom: "60%",
                  }}
                >
                  <i class="fa-solid fa-caret-up"></i>
                </span>
                <span>
                  {filteredData.pvsystGHISum && filteredData.actualGHISum
                    ? Number(
                        Number(
                          ((filteredData.actualGHISum -
                            filteredData.pvsystGHISum) *
                            100) /
                            filteredData.pvsystGHISum
                        ).toFixed(2)
                      )
                    : "N/A"}
                </span>
              </div>
            </div>
          </div>
          <div>
            <div>
              <span>{filteredData.pvsystGHISum || "N/A"}</span>
              <span>PVsyst GHI (kWh/m^2)</span>
              <div style={{ width: "80%", height: 30 }}>
                <ResponsiveContainer>
                  <ComposedChart
                    margin={{
                      top: 0,
                      bottom: 0,
                      left: 0,
                      right: 0,
                    }}
                    data={
                      GHIGTI?.reduce((acc, curr) => {
                        if (curr["PVsyst GHI"] && curr["Date"]) {
                          acc.push(curr);
                        }
                        return acc;
                      }, []) || []
                    }
                  >
                    <XAxis dataKey="Date" hide />
                    {/* <Tooltip content={<CustomizeTootip active={false} payload={[]} label={""} TooltipValues={["PVsyst GHI"]} />} /> */}
                    <Bar
                      barSize={4}
                      radius={14}
                      dataKey="PVsyst GHI"
                      fill="#8884d8"
                    />
                  </ComposedChart>
                </ResponsiveContainer>
              </div>
              <span
                className="progress_button_1"
                onMouseEnter={() =>
                  setProgressValueAnimate({
                    ...progressValueAnimate,
                    progress4: true,
                  })
                }
                onMouseOut={() =>
                  setProgressValueAnimate({
                    ...progressValueAnimate,
                    progress4: false,
                  })
                }
              >
                View
              </span>
            </div>
            <div>
              <span>{filteredData.actualGHISum || "N/A"}</span>
              <span>Actual GHI (kWh/m^2)</span>
              <div style={{ width: "80%", height: 30 }}>
                <ResponsiveContainer>
                  <ComposedChart
                    margin={{
                      top: 0,
                      bottom: 0,
                      left: 0,
                      right: 0,
                    }}
                    data={
                      GHIGTI?.reduce((acc, curr) => {
                        if (curr["Actual GHI"] && curr["Date"]) {
                          acc.push(curr);
                        }
                        return acc;
                      }, []) || []
                    }
                  >
                    <XAxis dataKey="Date" hide />
                    {/* <Tooltip content={<CustomizeTootip active={false} payload={[]} label={""} TooltipValues={["Actual GHI"]} />} /> */}
                    <Bar
                      barSize={4}
                      radius={14}
                      dataKey="Actual GHI"
                      fill="#8884d8"
                    />
                  </ComposedChart>
                </ResponsiveContainer>
              </div>
              <span
                onMouseEnter={() =>
                  setProgressValueAnimate({
                    ...progressValueAnimate,
                    progress5: true,
                  })
                }
                onMouseOut={() =>
                  setProgressValueAnimate({
                    ...progressValueAnimate,
                    progress5: false,
                  })
                }
                className="progress_button_2"
              >
                View
              </span>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PvsystActualGHIContainer;
